import { fetchRequests } from "@/services/api.services";
import { fetchDropdownValues } from "@/services/benchling/benchlingAPI";

const state = {
    loading: false,
    protocols: [],
    requests: [],
    statuses: [],
};

const getters = {
    isLoading: (state) => state.loading,
    protocols: (status) => state.protocols,
    requests: (state) => state.requests,
    statuses: (state) => state.statuses,
};

const actions = {
    addRequest({ commit, getters }, request) {
        commit("addRequest", { request });
    },
    async fetchRequests({ commit }, filter) {
        try {
            commit("startLoading");
            const response = await fetchRequests(filter);
            commit("setRequests", response.data);
            commit("setProtocols", response.meta.protocols);
        } catch (err) {
            console.log(err);
            throw new Error("Failed fetching requests");
        } finally {
            commit("stopLoading");
        }
    },
    async initialize({ commit }) {
        const response = await fetchDropdownValues("Request Status");
        commit("setStatuses", response);
    },
};

const mutations = {
    addRequest: (state, data) => {
        state.requests.push(data);
    },

    setRequests: (state, requests) => {
        state.requests = requests;
    },

    setStatuses: (state, statuses) => {
        state.statuses = statuses;
    },

    setProtocols: (state, protocols) => {
        state.protocols = protocols;
    },

    startLoading: (state) => (state.loading = true),
    stopLoading: (state) => (state.loading = false),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
